import { WalletSkeletonWhiteBox } from "../../../../style/skeleton";
import {
  WalletPubListItemPub,
  WalletPubListItemPubPoint,
  WalletPubListItemTopWrapper,
  WalletPubListItemWrapper,
} from "./style";

const WalletPubListSkeletonItem = () => {
  return (
    <WalletPubListItemWrapper isSelected={false}>
      <WalletPubListItemTopWrapper>
        <WalletPubListItemPub>
          <WalletSkeletonWhiteBox width="23px" height="23px" radius="50%" />
          <WalletSkeletonWhiteBox width="100px" height="20px" />
        </WalletPubListItemPub>
        <WalletPubListItemPubPoint>
          <WalletSkeletonWhiteBox width="40px" height="14px" />
          <img src={`/image-web/mypub/down-arrow.svg`} alt="" />
        </WalletPubListItemPubPoint>
      </WalletPubListItemTopWrapper>
    </WalletPubListItemWrapper>
  );
};

export default WalletPubListSkeletonItem;
